import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  height: 262px;

  background: ${({ theme }) => theme.colors.gray[100]};

  box-shadow: ${({ theme }) => theme.shadow.default};
  border-radius: 8px;

  .lineContainer {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;

    div {
      display: flex;
      gap: 16px;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;
